module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#pinterest",
      toString: function () {
        return this.url;
      }
    }